<template>
  <div
    class="avatar"
    :style="style"
    @click="handleClick"
    data-testid="components-avatar-click"
  >
    <div v-if="editabled">
      <svg-icon
        name="edit-line"
        :size="iconSize"
        class="edit-avatar"
        padding="0"
      />
      <ImgSelect
        ref="imgSelect"
        :cur-src="url"
        :img-list="imgList"
        @select="handleSelect"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue';
import ImgSelect from '@C/ImgSelect.vue';

export default defineComponent({
  name: 'Avatar',
  components: {
    ImgSelect
  },
  props: {
    size: {
      type: [Number, String],
      default: 36
    },
    url: {
      type: String,
      default: ''
    },

    editabled: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: [Number, String],
      default: 24
    },

    imgList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['select'],
  setup(props, { emit }) {
    const imgSelect = ref(null);
    const style = computed(() => {
      return {
        backgroundImage: `url(${props.url})`,
        height: `${props.size}px`,
        width: `${props.size}px`,
        cursor: props.editabled ? 'pointer' : 'default'
      };
    });
    const handleSelect = url => {
      emit('select', url);
    };
    const handleClick = () => {
      if (props.editabled) {
        imgSelect.value.show();
      }
    };

    return {
      style,
      handleSelect,
      handleClick,
      imgSelect
    };
  }
});
</script>

<style scoped lang="less">
.avatar {
  background-size: cover;
  border-radius: 50%;
  position: relative;
  .edit-avatar {
    color: var(--theme-color);
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
</style>
